// extracted by mini-css-extract-plugin
export default {"header":"UrxlZpuOXqd0M1CEJUAr","welcome":"SnZbzM0BwPonr3mkjHbm"};